import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { BiRocket, BiBarChart } from 'react-icons/bi';
import BigNumbers from './big-numbers';

const Stats = ({ progress, maturity }) => (
  <Row style={{ marginTop: '10px' }}>
    <Col md={6}>
      <BigNumbers
        amount={progress}
        title='Progresso'
        backgroundColor='#c2d2e9'
        borderColor='#677c9b'
        icon={<BiBarChart />}
      />
    </Col>
    <Col md={6}>
      <BigNumbers
        amount={maturity}
        title='Maturidade'
        backgroundColor='#bee1dd'
        borderColor='#4fa569'
        icon={<BiRocket />}
      />
    </Col>
  </Row>
);

export default Stats;
